export const TIDS = {
  // Nav
  navLogo: "nav-logo",
  navServices: "nav-services",
  navAbout: "nav-about",
  navPricing: "nav-pricing",
  navBooking: "nav-booking",
  navContact: "nav-contact",
  navLogin: "nav-login",
  navRegister: "nav-register",
  navDashboard: "nav-dashboard",
  navAdmin: "nav-admin",
  navLogout: "nav-logout",

  // Landing
  heroCta: "hero-cta",
  heroSecondary: "hero-secondary",

  // Auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  loginError: "login-error",
  registerName: "register-name",
  registerArtistName: "register-artist-name",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerSubmit: "register-submit",
  registerError: "register-error",

  // Booking
  bookingName: "booking-name",
  bookingEmail: "booking-email",
  bookingPhone: "booking-phone",
  bookingService: "booking-service",
  bookingNotes: "booking-notes",
  bookingDate: "booking-date",
  bookingSlot: "booking-slot",
  bookingSubmit: "booking-submit",
  bookingSuccess: "booking-success",

  // Contact
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactSubject: "contact-subject",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",
  contactSuccess: "contact-success",

  // Dashboard
  artistDashboard: "artist-dashboard",
  royaltyTotal: "royalty-total",
  royaltyPending: "royalty-pending",
  royaltyReceived: "royalty-received",

  // Admin
  adminDashboard: "admin-dashboard",
  addRoyaltyBtn: "add-royalty-btn",
  addPlacementBtn: "add-placement-btn",
  royaltyArtist: "royalty-artist",
  royaltyType: "royalty-type",
  royaltySource: "royalty-source",
  royaltyPeriod: "royalty-period",
  royaltyAmount: "royalty-amount",
  royaltyStatus: "royalty-status",
  royaltySubmit: "royalty-submit",
};
